export default __webpack_public_path__ + "static/media/q8-app.b8cec239.png";